import {fitDimensionSizes} from "./measurementDimensions.ts";
import type {CalculationRequest,Measurement} from "./types";

export function initialCalculation(measurement: Measurement, initial?: CalculationRequest | null): CalculationRequest {
  const opening = measurement.constructionType === "Дверь" ? "DoorLeft" : "Fixed";
  const columns = Math.max(1, initial?.sections?.length ?? 1);
  const rows = Math.max(1, initial?.rowCount ?? 1);
  const widths = fitDimensionSizes(measurement.widthMm, initial?.sections?.map(section => section.widthMm) ?? [], columns);
  const cells = Array.from({ length: columns * rows }, (_, index) => initial?.cellOpenings?.[index] ?? initial?.sections?.[index % columns]?.opening ?? opening);
  return {
    templateId: initial?.templateId ?? "", profileSystem: initial?.profileSystem ?? measurement.profileSystem,
    widthMm: measurement.widthMm, heightMm: measurement.heightMm,
    sashCount: cells.filter(cell => cell !== "Fixed").length, quantity: initial?.quantity ?? 1,
    includeInstallation: initial?.includeInstallation ?? false, glazing: measurement.glazing,
    hardware: measurement.hardware, color: measurement.color, comment: measurement.comment,
    sections: widths.map((widthMm, index) => ({ widthMm, opening: cells[index] })), rowCount: rows,
    rowHeightsMm: fitDimensionSizes(measurement.heightMm, initial?.rowHeightsMm?.length === rows && initial.rowHeightsMm.every(value => value > 0) ? initial.rowHeightsMm : [], rows), cellOpenings: cells,
    profileSelection: initial?.profileSelection ?? {},
    decorationSystemId: initial?.decorationSystemId ?? null,
    catalogSelection: initial?.catalogSelection ?? [],
    workshop: initial?.workshop ?? null,
    pvcWorkshop: initial?.pvcWorkshop ?? null,
    accessories: initial?.accessories ?? [],
    materialOverrides: initial?.materialOverrides ?? [],
    stockReservationId: initial?.stockReservationId ?? null,
    reinforcementStockLengthsMm: initial?.reinforcementStockLengthsMm ?? {},
    pvcConsumables: initial?.pvcConsumables ?? [],
    doorTransomHeightMm: initial?.doorTransomHeightMm ?? null,
    hardwareProductKey: initial?.hardwareProductKey ?? null,
    infillProductKey: initial?.infillProductKey ?? null,
    centralSealProductKey: initial?.centralSealProductKey ?? null,
  };
}
